import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/assets/css/sweetalert-custom.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './registerServiceWorker'

const syncStoredTheme = () => {
  setTimeout(() => {
    if (typeof window.applyStoredTheme === 'function') {
      window.applyStoredTheme()
    }
  }, 0)
}

router.afterEach(syncStoredTheme)

createApp(App).use(router).mount('#app')
syncStoredTheme()
